import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@src/store/rootState";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export const getVariationMods = createSelector(
  (state: RootState) => state.experienceBuilder.mods,
  experienceBuilderSlice.selectors.getVariationId,
  (mods, variationId) => {
    return mods.filter((m) => m.variationId === variationId);
  }
);
